import React from 'react';
import HeaderOne from '../../common/header/HeaderOne';
import BreadcrumbOne from '../../common/breadcrumb/BreadcrumbOne';
import AttorneyLeftSidebarThreeGridSectionOne from '../../components/attorney-components/AttorneyLeftSidebarThreeGridSectionOne';
import FooterOne from '../../common/footer/FooterOne';

const AttorneyLeftSidebarThreeGridOne = () => {
    return (
        <>
        <HeaderOne />

        <BreadcrumbOne 
            title="Attorney Left Sidebar Three Grid 1"
            rootUrl="/"
            parentUrl="Home"
            currentUrl="Attorney Left Sidebar Three Grid 1"
        />
        
        <AttorneyLeftSidebarThreeGridSectionOne />
        
        <FooterOne />
        </>
    )
}
    
export default AttorneyLeftSidebarThreeGridOne;